import React from 'react';
import './harbour.css';

/*
 * The statement school staff accept before using the tool (TDI-358), word for
 * word from the frame (4025:112282). One copy, two surfaces: the referral
 * wizard's "Important information" page (HarbourAddToReferralFlyout) and the
 * teacher's first-visit screen (TDI-489). Do not reword without the TDI-358
 * sign-off.
 */
export default function HarbourSchoolStaffStatement() {
  return (
    <>
      <div className="harbour-important flex flex-col gap-3">
        <h3 className="harbour-title-20">For teachers and education staff</h3>
        <p className="harbour-body-16">
          This tool is designed to support professional judgement and help identify whether a child, young
          person, or family may benefit from additional support or a referral. It can assist with gathering
          information and signposting to appropriate services.
        </p>
        <p className="harbour-body-16">
          This tool <strong>does not make clinical decisions</strong>, provide diagnoses, or replace
          professional assessment and judgement. Any decisions about care, support, or referrals remain the
          responsibility of the relevant professionals.
        </p>
        <p className="harbour-body-16">
          Please note that this tool is not a replacement for existing urgent/safeguarding referral pathways.
          Including but not limited to:
        </p>
        <ul className="harbour-important__list harbour-body-16">
          <li>Children&rsquo;s Mental Health Services (CAMHS)</li>
          <li>Safeguarding services</li>
          <li>Children&rsquo;s Social Care</li>
          <li>Emergency or crisis support services</li>
        </ul>
        <p className="harbour-body-16">
          Where there are concerns about a child&rsquo;s safety, wellbeing, mental health, or immediate needs,
          you should continue to follow your organisation&rsquo;s existing policies, procedures, and referral
          pathways. Referrals to these services should still be made directly where appropriate.
        </p>
      </div>
      <div className="harbour-important__confirm harbour-body-16-bold">
        By continuing to use this tool, you confirm that you understand its purpose and limitations and will
        use it alongside your professional judgement and local safeguarding procedures.
      </div>
    </>
  );
}
